import { Component, OnInit, ViewChild } from '@angular/core';
import { Usuario, Organizacao, Emissao, StatusFatoresAltenticacao } from '../shared/index';
import { LoginService } from '../shared/service/login/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CertificadoService } from '../shared/service/certificado/certificado.service';
import { Location } from '@angular/common';
import { UtilService } from '../shared/service/util/util.service';
import { CertificadoComunicacaoService } from '../shared/service/certificado-comunicacao/certificado-comunicacao.service';
import { CertificadoComunicacao } from '../shared/model/certificadoComunicacao';

@Component({
  selector: 'app-emissao-renovacao',
  templateUrl: './emissao-renovacao.component.html',
  styleUrls: ['./emissao-renovacao.component.css']
})
export class EmissaoRenovacaoComponent implements OnInit {

  public statusFatoresAltenticacao: StatusFatoresAltenticacao;
  public usuario: Usuario;
  public organizacao: Organizacao;
  public emissao: Emissao;
  public confirm: string;
  public otpCadastrado: boolean;
  public disabledEmitirSubmit: boolean = false;
  public regex: string;
  public certificadosComunicacao: CertificadoComunicacao[] = [];
  public certificadoComunicacaoId: string;

  @ViewChild('f', { static: true }) form;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private certificadoService: CertificadoService,
    private utilService: UtilService,
    private certificadoComunicacaoService: CertificadoComunicacaoService,
    private loginService: LoginService,
    private location: Location) {

  }

  ngOnInit() {
    this.usuario = this.route.snapshot.data['obterDadosUsuario'];
    this.usuario.organizacaoId = JSON.parse(localStorage.getItem('currentUser')).organizacaoId;
    this.emissao = new Emissao();
    this.verificaOtp();
    this.listarCertificadosComunicacao();
    this.regex = '^[0-9]+$';
  }

  verificaOtp() {
    this.certificadoService.getStatusFatores(this.usuario.id, this.usuario.organizacaoId).subscribe(
      res => {
        this.otpCadastrado = res.tokenOtpObrigatorio;
      },
      err => {
        this.utilService.showError(err.message);
        if (err.status === 401 || err.status === 403) {
          this.loginService.logout();
        }
      }
    );
    return false;
  }

  listarCertificadosComunicacao() {
    this.certificadoComunicacaoService.listar(this.usuario.organizacaoId).then((request) => {
      this.certificadosComunicacao = request;
      this.certificadoComunicacaoId = this.certificadosComunicacao[0].id.toString();

    }).catch((err) => {
      this.utilService.showError(err);
      if (err.status === 401 || err.status === 403) {
        this.loginService.logout();
      }
    });
  }

  emitir() {
    this.disabledEmitirSubmit = true;
    this.emissao.idCertificadoComunicacao = Number(this.certificadoComunicacaoId);
    
    this.certificadoService.emitirRenovacaoCertificado(this.usuario, this.emissao).subscribe(
      () => {
        this.router.navigate(['/carteira-certificado']);
        localStorage.setItem("message", "Renovação de Certificado Emitido com Sucesso.")
      },
      err => {
        this.disabledEmitirSubmit = false;
        this.utilService.showError(err.message);
        if (err.status === 401 || err.status === 403) {
          this.loginService.logout();
        }
      }
    );
  }

  resetForm() {
    this.form.resetForm();
  }

  cancelar() {
    this.location.back();
  }
}
